
export const actionTypes = {
  UPDATE_TITLE: 'title.update-title',
  UPDATE_MESSAGE: 'title.update-message'
};

const mainTitle = 'Self-Service Portal';

export function updateTitle(value) {
  var title = value ? mainTitle + ': ' + value : mainTitle;
  document.title = title;

  return {
    type: actionTypes.UPDATE_TITLE,
    value: title
  }
}

export function updateMessage(value) {
  return {
    type: actionTypes.UPDATE_MESSAGE,
    value
  }
}



// WEBPACK FOOTER //
// src/common/title/title.actions.js